// Servers are defined in /config/servers.js — edit there to add/remove servers
export { SERVERS } from '../config/servers.js'

export const ENDPOINTS = {
  deploy: (base, number) => `${base}?number=${encodeURIComponent(number)}`,
  active: (base) => `${base}/active`,
  ping:   (base) => `${base}/ping`,
}

export const POLL_INTERVAL_MS = 30_000

export const NAV_LINKS = [
  { path: '/',        label: 'Deploy'  },
  { path: '/servers', label: 'Servers' },
  { path: '/contact', label: 'Contact' },
  { path: '/privacy', label: 'Privacy' },
]
